import { Injectable } from '@angular/core';

const OPEN_OVERLAY_SELECTORS = [
  '.cdk-overlay-pane .ant-select-dropdown',
  '.cdk-overlay-pane .ant-picker-dropdown',
  '.cdk-overlay-pane .ant-dropdown',
  '.cdk-overlay-pane .ant-cascader-dropdown',
  '.cdk-overlay-pane .ant-mention-dropdown',
].join(', ');

@Injectable({ providedIn: 'root' })
export class OverlayCloseService {
  private outsideClickTarget: HTMLElement | null = null;

  closeOpenDropdownLikeOverlays(): boolean {
    if (typeof document === 'undefined') {
      return false;
    }

    const hasOpenOverlay = !!document.querySelector(OPEN_OVERLAY_SELECTORS);
    if (!hasOpenOverlay) {
      return false;
    }

    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) {
      activeElement.blur();
    }

    const outsideTarget = this.getOutsideClickTarget();
    outsideTarget.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
    outsideTarget.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true }));
    outsideTarget.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    return true;
  }

  private getOutsideClickTarget(): HTMLElement {
    if (this.outsideClickTarget && document.body.contains(this.outsideClickTarget)) {
      return this.outsideClickTarget;
    }

    const target = document.createElement('button');
    target.type = 'button';
    target.tabIndex = -1;
    target.setAttribute('aria-hidden', 'true');
    target.style.position = 'fixed';
    target.style.left = '-10000px';
    target.style.top = '-10000px';
    target.style.width = '1px';
    target.style.height = '1px';
    target.style.opacity = '0';
    target.style.pointerEvents = 'none';
    document.body.appendChild(target);
    this.outsideClickTarget = target;
    return target;
  }
}
